<template>
  <div>
    <template v-if="selectItemsFlag">
      <div class="product-list">
        <slot></slot>
        <SelectItems
          :label="input.label"
          :defaults="statusItems"
          @select="onItemsSelected"
          @back="goBack"
        ></SelectItems>
      </div>
    </template>
    <template v-else>
      <div class="centered-block">
        <StepTitle hr>
          Item Details
          <template v-if="(statusItems.length > 1)" #product>
            <div class="selected-item">{{slide + 1}}/{{statusItems.length}}</div>
          </template>
          <template v-if="(statusItems.length > 1)" #subtitle>
            <span class="d-none d-md-inline-block">Use the side arrows</span><span class="d-md-none">Swipe sideways</span><span> to review more items</span>
          </template>
        </StepTitle>
      </div>
      <b-carousel
        class="item-status-carousel"
        v-model="slide"
        :interval="0"
        :controls="(statusItems.length > 1)"
      >
        <b-carousel-slide v-for="item in statusItems" :key="'item-' + item.id">
          <OrderItemStatus
            :item="item"
            @edit="editItem"
          ></OrderItemStatus>
        </b-carousel-slide>
      </b-carousel>
      <b-row class="justify-content-md-center boxes select-item-btn customer-verify">
        <b-col v-if="session && session.can_undo" md="4" lg="3" sm="6" cols="6">
          <button type="button" @click="goBack()" class="btn-block btn-base input-choice-btn new-btn-outline-success stroke-2x">Back</button>
        </b-col>
        <b-col md="4" lg="3" sm="6" cols="6">
          <button type="button" @click="done()" class="btn-base input-choice-btn stroke-2x">
            <span class="inline-button-label" v-html="input.formatted_label"></span>&nbsp;
            <font-awesome-icon :icon="['fas', 'caret-right']" class="footer_btn"></font-awesome-icon>
          </button>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const StepTitle = () => import('./StepTitle')
const SelectItems = () => import('./SelectItems')
const OrderItemStatus = () => import('./OrderItemStatus')

export default {
  name: 'OrderItems',
  components: {SelectItems, OrderItemStatus, StepTitle},
  props: {
    input: Object,
    items: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data: function() {
    return {
      slide: 0,
      selectItemsFlag: false
    }
  },
  computed: {
    ...mapState(['session', 'statusItems'])
  },
  methods: {
    done: function() {
      this.$emit('submit', this.input) // we're done with the item status view, move on to the next step
    },
    goBack: function() {
      if (this.selectItemsFlag || this.session.selected_item) {
        this.$emit('back') // we're viewing the item list, go back to the previous step
      } else {
        this.selectItemsFlag = true // we're viewing the selected item's details, go back to the item list
      }
    },
    onItemsSelected: function(items) {
      if (items.length) {
        this.$store.commit('set_status_items', items)
        this.selectItemsFlag = false // items selected, show the details
      } else {
        this.done() // no items, so nothing to do here - just move on to the next step
      }
    },
    editItem: function(input, item) {
      this.$store.commit('select_item', item)
      this.$emit('edit', input, item)
    }
  },
  created() {
    this.$store.commit('set_status_items', this.items) // we'll use the array of items that we passed in

    if (this.statusItems.length) {
      this.selectItemsFlag = false // we already have selected items, so show their details

      // get the default slide from the session
      if (this.session.selected_item) {
        for (let i = 0; i < this.statusItems.length; i++) {
          if (this.statusItems[i].id === this.session.selected_item.id) {
            this.slide = i
            break
          }
        }
      }
    } else {
      this.selectItemsFlag = true // no items selected yet, so select them
    }
  }
}
</script>

<style scoped>

</style>
